import * as authentication from "../../common/actions/authentication";
import * as order from "../actions/order.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        active: {
            loading: false,
            submitting: false,
            shipmentId: null,
            distributionRouteId: "",
            deliveryDate: "",
        },
        productView: {
            view: "item",
            category: "all"
        },
        orderFeeLimits: [],
        orderVolumeDiscounts: [],
        freshFoodTemplateData : 
        {
            products: [],
            freshFoodProducts: [],
        }
    });
};

/**
 * View reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case order.SET_PRODUCT_ORDER_VIEW:
        return state.merge({
            productView:{
                view: action.value
            }
        });
    case order.SET_ORDER_FEE_LIMITS:
        return Immutable.setIn(state, ["orderFeeLimits"], action.orderFeeLimits);
    case order.SET_ORDER_VOLUME_DISCOUNTS:
        return Immutable.setIn(state, ["orderVolumeDiscounts"], action.orderVolumeDiscounts);
    case order.SET_ACTIVE_ORDER:
        return state.merge({
            active: {
                ...action.activeOrder,
            }
        });
    case order.MERGE_ACTIVE_ORDER:
        return state.merge({
            active: {
                ...state.active,
                ...action.activeOrderChange,
            }
        });
    case order.ADD_TO_UNCONFIRMED_ORDER:
        if( state.active.unConfirmedOrderLines ){
            return Immutable.setIn(state, ["active","unConfirmedOrderLines"], [action.line].concat(state.active.unConfirmedOrderLines));
        } else {
            return Immutable.setIn(state, ["active","unConfirmedOrderLines"], [action.line]);
        }
    case order.REMOVE_FROM_UNCONFIRMED_ORDER:
        return Immutable.setIn(state, ["active","unConfirmedOrderLines"], Immutable(state.active.unConfirmedOrderLines).filter( (item) => item.product.productId!==action.productId));
    case order.UPDATE_UNCONFIRMED_ORDER_LINE:
        return Immutable.setIn(state, ["active","unConfirmedOrderLines",state.active.unConfirmedOrderLines.findIndex( (item) => item.productId===action.productId)], action.line);
    case order.SET_UNCONFIRMED_ORDER_LINE_INFO:
    {
        const index = state.active.unConfirmedOrderLines ? state.active.unConfirmedOrderLines.findIndex( (item) => item.productId===action.productId) : -1;
        return Immutable.setIn(state, ["active","unConfirmedOrderLines",index], {
            ...action.line,
            orderedQty: state.active.unConfirmedOrderLines[index].orderedQty,//we are only updating information
        });
    }
    case order.SET_UNCONFIRMED_ORDER_LINE_LOADING:
    {
        const index = state.active.unConfirmedOrderLines ? state.active.unConfirmedOrderLines.findIndex( (item) => item.productId===action.productId) : -1;
        return Immutable.setIn(state, ["active","unConfirmedOrderLines",index,"loading"], action.loading);
    }
    case order.SET_ACTIVE_ORDERED_IMAGE_URL:
        return state.merge({
            active:{
                orderLines: Immutable(state.active.orderLines).map(function(obj, index) {
                    return (index === action.index) ? {
                        ...obj,
                        product: {
                            ...obj.product,
                            imageUrl:action.imageUrl
                        }
                    } : obj;
                })
            }
        }, {
            deep: true
        });
    case order.SET_ACTIVE_ORDER_LOADING:
        return state.merge({
            active:{
                loading: action.loading,
            }
        }, {
            deep: true
        });
    case order.SET_ACTIVE_ORDER_SUBMITTING:
        return state.merge({
            active:{
                submitting: action.submitting,
            }
        }, {
            deep: true
        });
    case order.SET_ACTIVE_UNCONFIRMEDORDER_IMAGE_URL:
        return state.merge({
            active:{
                unConfirmedOrderLines: Immutable(state.active.unConfirmedOrderLines).map(function(obj, index) {
                    return (index === action.index) ? {
                        ...obj,
                        product: {
                            ...obj.product,
                            imageUrl:action.imageUrl
                        }
                    } : obj;
                })
            }
        }, {
            deep: true
        });
    case order.SET_FRESHFOOD_TEMPLATE:
        return state.merge({
            freshFoodTemplateData: action.templateData
        });
    case order.SET_FRESHFOOD_TEMPLATE_UPDATED:
        return state.merge({
            freshFoodTemplateData: {
                products: Immutable(state.freshFoodTemplateData.products).map(function(prd) {
                    return (prd.productId === action.product.productId) ? action.product : prd;
                })
            }
        }, {
            deep: true
        });
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}